import {  useEffect, useState } from 'react';
import {  toastText } from 'utils/utils';
import CompanyTable from './Table';
import { companySetup } from 'Api/companySetup';

type Props = {};

const CompanySetupComponent = (props: Props) =>{
	const [companyData, setCompanyData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isPayrollRun ,setIsPayrollRun] =useState(false)

	const fetchCompany = async () => {
		try {
			setIsLoading(true);
			const response = await companySetup.getCompanyDetails();
			setCompanyData(response?.data?.data);
			setIsPayrollRun(response?.data?.data[0]?.isPayrollRun);
		} catch (err: any) {
			const message =
				err?.response?.data?.message ||
				'Something went wrong in fetching company';
			toastText(message, 'error');
		} finally {
			setIsLoading(false);
		}
	};


		useEffect(() => {
		fetchCompany();
	}, []);

	return (
			<CompanyTable
				tableData={companyData}
				isLoading={isLoading}
				fetchCompany={fetchCompany}
				isPayrollRun={isPayrollRun} 
			/>
	);
}

export default CompanySetupComponent;
